/* eslint-disable css-modules/no-unused-class */
import { Icon } from 'learning-panel-components';
import { translate } from 'translations';
import styles from './primaryCourse.module.scss';

const PrimaryCourseEmptyStateBottom = () => {
    return (
        <div data-testid="primary-course-empty-bottom" className={styles['primary-course-empty-bottom']}>
            <div className={styles.lesson}>
                <Icon name="primaryEmptyLesson" />
                <div>{translate('Lesson')}</div>
            </div>
            <div className={styles.assessment}>
                <Icon name="primaryEmptyAssessment" />
                <div>{translate('Assessment')}</div>
            </div>
            <div className={styles.course}>
                <Icon name="primaryEmptyCourse" />
                <div>{translate('Course')}</div>
            </div>
            <div className={styles.challenge}>
                <Icon name="primaryEmptyChallenge" />
                <div>{translate('Challenge')}</div>
            </div>
            <div className={styles.tournament}>
                <Icon name="primaryEmptyTournament" />
                <div>{translate('Tournament')}</div>
            </div>
        </div>
    );
};

export default PrimaryCourseEmptyStateBottom;
